import { store } from '@betacrew/jars-flux';
import { all, call, put, takeLatest, takeLeading } from 'redux-saga/effects';
import SignInDataService from '../../../../services/SignInDataService';
import { ENDPOINT_RESULT_TYPE, PAGE_STATE } from '../../constants/constants';
import { PRE_LOGIN_LOADING_STATES } from '../constants';
import { componentKey, setEndpointResult, resetForms, setLoadingState, setValidResetToken, setResetPasswordFormFields } from './ForgotPasswordSlice';

export const { setPasswordResetLink, validateToken, setPassword } = {
    setPasswordResetLink: (payload) => {
        return {
            type: "SIGN_IN/SEND_PASSWORD_RESET",
            payload: payload
        }
    },
    validateToken: (payload) => {
        return {
            type: "SIGN_IN/VALIDATE_RESET_TOKEN",
            payload: payload
        }
    },
    setPassword: (payload) => {
        return {
            type: "SIGN_IN/RESET_PASSWORD",
            payload: payload
        }
    }
}
function* setPasswordResetLinkAsync(action) {
    try {
        yield put(setEndpointResult({showMessage: false, message: ""}));
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.FORGOT_PASSWORD_PAGE_LOADING }));
        const response = yield SignInDataService.forgotPasswordRequest(action.payload);
        if(response){
            if(response?.data?.Status){
                yield put(setEndpointResult({showMessage: true, message: response?.data?.Message, resulType: ENDPOINT_RESULT_TYPE.SUCCESS}));
                yield put(resetForms());
            }else{
                yield put(setEndpointResult({showMessage: true, message: response?.data?.Message, resulType: ENDPOINT_RESULT_TYPE.ERROR}));
            }
        }
    } catch (error) {
        yield put(setEndpointResult({showMessage: true, message: error?.response?.data?.Message, resulType: ENDPOINT_RESULT_TYPE.ERROR}));
    } finally {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.FORGOT_PASSWORD_PAGE_READY }));
    }
}
function* validateTokenAsync(action){
    try {
        yield put(setEndpointResult({showMessage: false, message: ""}));
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SET_PASSWORD_PAGE_LOADING }));
        const response = yield SignInDataService.validateResetToken(action.payload);
        if(response?.data){
            if(response.data.Status){
                yield call(setResetPasswordFormFieldsAsync, {payload: {
                    email: action.payload.email,
                    token: action.payload.token,
                    GRecaptchaResponse: action.payload.GRecaptchaResponse,
                }});
                yield put(setValidResetToken(true));
                yield put(setEndpointResult({showMessage: false, message: "", resulType: ENDPOINT_RESULT_TYPE.SUCCESS}));
            }else{
                yield put(setEndpointResult({showMessage: true, message: "You have accessed an invalid url", resulType: ENDPOINT_RESULT_TYPE.ERROR}));
            }
        }
    }catch {
        yield put(setEndpointResult({showMessage: true, message: "Invalid request. Please try again.", resulType: ENDPOINT_RESULT_TYPE.ERROR}));
    } finally {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SET_PASSWORD_PAGE_READY }));
    }
}

function* setResetPasswordFormFieldsAsync(action){
    yield put(setResetPasswordFormFields(action.payload))
}

function* setPasswordAsync(action){
    try {
        yield put(setEndpointResult({showMessage: false, message: ""}));
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SET_PASSWORD_PAGE_LOADING }));
        const response = yield SignInDataService.setPassword(action.payload);
        if(response?.data){
            if(response?.data?.Status){
                yield put(setEndpointResult({showMessage: true, message: response?.data?.Message, resulType: ENDPOINT_RESULT_TYPE.SUCCESS}));
                yield put(setValidResetToken(false));
                yield put(resetForms());
            }else{
                yield put(setEndpointResult({showMessage: true, message: response?.data?.Message, resulType: ENDPOINT_RESULT_TYPE.ERROR}));
            }
        }
    } catch (error) {
        yield put(setEndpointResult({showMessage: true, message: error?.response?.data?.Message, resulType: ENDPOINT_RESULT_TYPE.ERROR}));
    } finally {
        yield put(setLoadingState({ state: PRE_LOGIN_LOADING_STATES.SET_PASSWORD_PAGE_READY }))
    }
}

function* rootSaga() {
    yield all([
        takeLatest(setPasswordResetLink().type, setPasswordResetLinkAsync),
        takeLatest(validateToken().type, validateTokenAsync),
        takeLatest(setPassword().type, setPasswordAsync),
    ]);
}
store.sagaManager.addSaga(componentKey, rootSaga);